<template>
  <b-form-input
      :id="id"
      :name="`input-${id}`"
      :data-cy="`input-${id}`"
      :placeholder="placegolder"
      :state="state"
      :v-validate="validation"
      v-model="displayValue"
      @blur="onFocus(false)"
      @focus="onFocus(true)"
      :class="clases"
      :disabled="disabled"
  />
</template>
<script>
import RutMixin from '@/febos/chile/_vue/mixins/RutMixin';

export default {
  name: 'BFormInputRut',
  mixins: [RutMixin],
  data() {
    return {
      isInputActive: false
    };
  },
  methods: {
    onFocus(active) {
      this.isInputActive = active;
      if (!active) {
        this.$emit('blur');
      } else {
        this.$emit('focus');
      }
    },
    cleanRut(_value) {
      return typeof _value === 'string' ? _value.replace(/[^0-9kK]+/g, '').toUpperCase() : '';
    },
    formatRut(_value, punto = false, _default = '') {
      const numberTruncate = punto ? 12 : 10;
      if (!_value) {
        return _value;
      }
      let value = _value;
      value = this.cleanRut(value);
      if (!value) return _default;
      if (value.length <= 1) return value;
      let result = `${value.slice(-4, -1)}-${value.substr(value.length - 1)}`;
      for (let i = 4; i < value.length; i += 3) result = value.slice(-3 - i, -i) + (punto ? '.' : '') + result;
      return this.truncateValue ? result.substring(0, numberTruncate) : result;
    }
  },
  computed: {
    displayValue: {
      get() {
        return this.formatRut(this.value, this.displaypunto);
      },
      set(modifiedValue) {
        this.$emit('input', this.formatRut(modifiedValue, this.valuepunto));
      }
    },
    validation() {
      if (typeof this.vValidate === 'object') {
        return {
          ...this.vValidate,
          validateRut: true
        };
      }
      return this.vValidate ? `${this.vValidate}|validateRut` : 'validateRut';
    }
  },
  props: {
    id: {
      type: String,
      requited: true
    },
    value: {
      type: String,
      default: ''
    },
    vValidate: {
      type: [String, Object],
      default: ''
    },
    placegolder: {
      type: String,
      default: '12.345.678-0'
    },
    state: {
      type: Boolean
    },
    disabled: { type: Boolean, required: false, default: false },
    valuepunto: { type: Boolean, required: false, default: false },
    displaypunto: { type: Boolean, required: false, default: false },
    truncateValue: { type: Boolean, required: false, default: false },
    clases: { type: String, required: false },
  }
};
</script>
